import CityPageTemplate from './CityPageTemplate';

export default function ClermontPage() {
  return (
    <CityPageTemplate
      city="Clermont"
      county="Lake"
      slug="clermont"
      zipCodes={['34711', '34714', '34715']}
      neighborhoods={['Downtown Clermont', 'Kings Ridge', 'Legends', 'Lost Lake', 'Clermont Waterfront']}
      localContext="Serving Clermont's rolling hills and lakefront communities — from Kings Ridge to the downtown waterfront, where homeowners expect a spotless finish."
      metaDescription="Professional residential and commercial cleaning services in Clermont, FL. Serving ZIP codes 34711, 34714 & 34715. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
